<div
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  class="productContainerModal"
>
  <div
    cdkDragHandle
    class="flex items-center px-[15px] pb-[10px] border-b-[1px] border-primary sticky top-0 left-0 bg-white z-20 pt-6 w-full cursor-move"
  >
    <img
      src="assets/images/new-images/logo-2.png"
      class="flex-[0_0_10%] header-image w-[90px] h-[26.89px]"
      routerLink="/dashboard"
    />

    <h2 class="font-semibold m-[0_auto] space-x-1 text-xl text-center">
      <span i18n="@@editButton" *ngIf="isViewMode">Edit</span>
      <span i18n="@@new" *ngIf="!isViewMode">New</span>
      <span i18n="@@loan_product">Loan Product</span>
    </h2>
    <mat-icon class="text-red-500 text-4xl cursor-pointer" (click)="cancel()"
      >highlight_off</mat-icon
    >
  </div>

    <div class="flex flex-col gap-[5px] px-[15px] mt-[20px]">
        <h3 class="text-primary" i18n="@@loan_product_information">
            Loan Product Information
        </h3>
        <div class="flex flex-col rounded-[10px] bg-[#F2F2F2] overflow-x-auto">
            <div class="px-[15px]">
                <form [formGroup]="basicForm">
                    <div class="pb-[10px] pt-[15px] border-b-[1px] border-primary">
                        <div class="flex gap-[20px]">
                            <div class="flex items-center gap-[5px] w-[20.5%]">
                                <mat-label i18n="@@loan_product_name_field">Name <span class="text-error">*</span></mat-label>
                                <mat-form-field appearance="outline" class="short_height w-[80.5%]">
                                    <input type="text" matInput appRemoveSpaces appTitleCase formControlName="name" />
                                </mat-form-field>
                            </div>

                            <div class="flex items-center gap-[10px] w-[12.431%]">
                                <mat-label i18n="@@product_code_field">Code <span class="text-error">*</span></mat-label>
                                <mat-form-field appearance="outline" class="short_height w-[67.23%]">
                                    <input type="text" matInput appRemoveSpaces formControlName="code" />
                                </mat-form-field>
                            </div>

              <div class="flex items-center gap-[10px] w-[24.27%]">
                <!-- <mat-label i18n="@@fund_source">Fund Source*</mat-label>
                                    <mat-form-field appearance="outline" class="short_height w-[68%]">
                                        <mat-select multiple formControlName="fundSources">
                                            <mat-option [value]="fundSource?.id" *ngFor="let fundSource of fundSources">{{
                                                fundSource?.name }}</mat-option>
                                            </mat-select>
                                        </mat-form-field> -->
                <app-search-select-multiple
                  [fetchedList]="fundSources"
                  class="w-full"
                  [label]="fundSourceLabel"
                  [control]="fundSourceCtrl"
                  [type]="'client'"
                ></app-search-select-multiple>
              </div>

                            <div class="flex items-center gap-[10px] w-[35.34%]">
                                <mat-label i18n="@@description">Description</mat-label>
                                <mat-form-field appearance="outline" class="short_height w-[80.7%] textarea-input">
                                    <textarea matInput appRemoveSpaces appSentenceCase formControlName="description" rows="1"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex gap-[8px] justify-start mr-4">
                            <mat-checkbox i18n="@@require_guarantor" formControlName="requireGuarantor">
                                Require Guarantor
                            </mat-checkbox>
                            <mat-checkbox i18n="@@enable_on_web_client" formControlName="enableWebClients">
                                Enable on Web Client
                            </mat-checkbox>
                        </div>
                    </div>
                </form>
            </div>
            <div class="">
                <form [formGroup]="loanForm">
                    <div class="flex pl-[15px] pt-[15px] pr-[10px] pb-[20px]">
                        <div class="flex gap-[10px] border-r-[1px] border-primary pr-[10px] w-[54.73%]">
                            <!-- Row label column -->
                            <div class="w-[58px] shrink-0 flex flex-col">
                                <div class="mb-[24px] h-[35px]"></div>
                                <div class="flex flex-col gap-[5px]">
                                    <div class="h-[35px]"></div>
                                    <div class="h-[35px] flex items-center">
                                        <mat-label i18n="@@default_field">Default <span class="text-error">*</span></mat-label>
                                    </div>
                                    <div class="h-[35px] flex items-center">
                                        <mat-label i18n="@@minimum_field">Minimum <span class="text-error">*</span></mat-label>
                                    </div>
                                    <div class="h-[35px] flex items-center">
                                        <mat-label i18n="@@maximum_field">Maximum <span class="text-error">*</span></mat-label>
                                    </div>
                                </div>
                            </div>

              <!-- Principal column -->
              <div class="flex-1 flex flex-col min-w-0">
                <div
                  class="text-center mb-[24px] h-[35px] flex items-center justify-center"
                >
                  <span
                    i18n="@@principal"
                    class="font-semibold leading-tight text-center"
                    >Principal</span
                  >
                </div>
                <div class="flex flex-col gap-[5px]">
                  <div class="h-[35px]"></div>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appCurrency
                      matInput
                      formControlName="defaultPrincipal"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultPrincipal',
                            min: 'minimumPrincipal',
                            max: 'maximumPrincipal'
                          },
                          'principal'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appCurrency
                      matInput
                      formControlName="minimumPrincipal"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultPrincipal',
                            min: 'minimumPrincipal',
                            max: 'maximumPrincipal'
                          },
                          'principal'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appCurrency
                      matInput
                      formControlName="maximumPrincipal"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultPrincipal',
                            min: 'minimumPrincipal',
                            max: 'maximumPrincipal'
                          },
                          'principal'
                        )
                      "
                    />
                  </mat-form-field>
                </div>
              </div>

              <!-- Interest Rate column -->
              <div class="flex-1 flex flex-col min-w-0">
                <div
                  class="text-center mb-[24px] h-[35px] flex items-center justify-center"
                >
                  <span
                    i18n="@@interest_rate"
                    class="font-semibold leading-tight text-center"
                    >Interest<br />Rate</span
                  >
                </div>
                <div class="flex flex-col gap-[5px]">
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <mat-label i18n="@@per">Per</mat-label>
                    <mat-select formControlName="interestPeriodUnit">
                      <mat-option value="DAY" i18n="@@dayOption"
                        >Day</mat-option
                      >
                      <mat-option value="WEEK" i18n="@@weekOption"
                        >Week</mat-option
                      >
                      <mat-option value="MONTH" i18n="@@monthOption"
                        >Month</mat-option
                      >
                      <mat-option value="YEAR" i18n="@@yearOption"
                        >Year</mat-option
                      >
                      <mat-option value="TENOR" i18n="@@tenorOption"
                        >Tenor</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      matInput
                      formControlName="defaultInterestRate"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultInterestRate',
                            min: 'minimumInterestRate',
                            max: 'maximumInterestRate'
                          },
                          'interest rate'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      matInput
                      formControlName="minimumInterestRate"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultInterestRate',
                            min: 'minimumInterestRate',
                            max: 'maximumInterestRate'
                          },
                          'interest rate'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      matInput
                      formControlName="maximumInterestRate"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultInterestRate',
                            min: 'minimumInterestRate',
                            max: 'maximumInterestRate'
                          },
                          'interest rate'
                        )
                      "
                    />
                  </mat-form-field>
                </div>
              </div>

              <!-- Loan Tenure column -->
              <div class="flex-1 flex flex-col min-w-0">
                <div
                  class="text-center mb-[24px] h-[35px] flex items-center justify-center"
                >
                  <span
                    i18n="@@loan_tenure"
                    class="font-semibold leading-tight text-center"
                    >Loan<br />Tenure</span
                  >
                </div>
                <div class="flex flex-col gap-[5px]">
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <mat-label i18n="@@period">Period</mat-label>
                    <mat-select
                      formControlName="loanPeriodLengthUnit"
                      (selectionChange)="selectedLoanTenorUnit($event)"
                    >
                      <mat-option value="DAY" i18n="@@dayOption"
                        >Day</mat-option
                      >
                      <mat-option value="WEEK" i18n="@@weekOption"
                        >Week</mat-option
                      >
                      <mat-option value="MONTH" i18n="@@monthOption"
                        >Month</mat-option
                      >
                      <mat-option value="YEAR" i18n="@@yearOption"
                        >Year</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="defaultLoanPeriodLength"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultLoanPeriodLength',
                            min: 'minimumLoanPeriodLength',
                            max: 'maximumLoanPeriodLength',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'loan tenor',
                          true
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="minimumLoanPeriodLength"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultLoanPeriodLength',
                            min: 'minimumLoanPeriodLength',
                            max: 'maximumLoanPeriodLength',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'loan tenor',
                          true
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="maximumLoanPeriodLength"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultLoanPeriodLength',
                            min: 'minimumLoanPeriodLength',
                            max: 'maximumLoanPeriodLength',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'loan tenor'
                        )
                      "
                    />
                  </mat-form-field>
                </div>
              </div>

              <!-- Repayment Frequency column -->
              <div class="flex-1 flex flex-col min-w-0">
                <div
                  class="text-center mb-[24px] h-[35px] flex items-center justify-center"
                >
                  <span
                    i18n="@@repayment_frequency"
                    class="font-semibold leading-tight text-center"
                    >Repayment<br />Frequency</span
                  >
                </div>
                <div class="flex flex-col gap-[5px]">
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <mat-label i18n="@@period">Period</mat-label>
                    <mat-select
                      formControlName="loanRepaymentFrequencyPeriodUnit"
                      (selectionChange)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultLoanPeriodLength',
                            min: 'minimumLoanPeriodLength',
                            max: 'maximumLoanPeriodLength',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'loan tenor',
                          true
                        )
                      "
                    >
                      <mat-option
                        [value]="repayment.value"
                        *ngFor="let repayment of repaymentFrequencyOptions"
                        >{{ repayment.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="loanRepaymentFrequency"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'defaultLoanPeriodLength',
                            min: 'minimumLoanPeriodLength',
                            max: 'maximumLoanPeriodLength',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'loan tenor',
                          true,
                          true
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="minimumLoanRepaymentFrequency"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'loanRepaymentFrequency',
                            min: 'minimumLoanRepaymentFrequency',
                            max: 'maximumLoanRepaymentFrequency',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'Repayment Frequency'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="maximumLoanRepaymentFrequency"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'loanRepaymentFrequency',
                            min: 'minimumLoanRepaymentFrequency',
                            max: 'maximumLoanRepaymentFrequency',
                            frequency: 'loanRepaymentFrequency'
                          },
                          'Repayment Frequency'
                        )
                      "
                    />
                  </mat-form-field>
                </div>
              </div>

              <!-- Grace Period column -->
              <div class="flex-1 flex flex-col min-w-0">
                <div
                  class="text-center mb-[24px] h-[35px] flex items-center justify-center"
                >
                  <span
                    i18n="@@grace_period"
                    class="font-semibold leading-tight text-center"
                    >Grace<br />Period</span
                  >
                </div>
                <div class="flex flex-col gap-[5px]">
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <mat-label i18n="@@period">Period</mat-label>
                    <mat-select formControlName="gracePeriodUnit">
                      <mat-option
                        [value]="gracePeriodUnit.value"
                        *ngFor="let gracePeriodUnit of gracePeriodUnits"
                        >{{ gracePeriodUnit.label }}</mat-option
                      >
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="gracePeriodLength"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'gracePeriodLength',
                            min: 'minimumGracePeriod',
                            max: 'maximumGracePeriod'
                          },
                          'grace period'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="minimumGracePeriod"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'gracePeriodLength',
                            min: 'minimumGracePeriod',
                            max: 'maximumGracePeriod'
                          },
                          'grace period'
                        )
                      "
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    class="short_height w-full"
                  >
                    <input
                      type="text"
                      appStrictNumbers
                      matInput
                      formControlName="maximumGracePeriod"
                      (blur)="
                        validateMinMaxInputs(
                          loanForm,
                          {
                            default: 'gracePeriodLength',
                            min: 'minimumGracePeriod',
                            max: 'maximumGracePeriod'
                          },
                          'grace period'
                        )
                      "
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>

                        <div class="flex flex-col pl-[10px] w-[34.04%]">
                            <div class="h-[35px] mb-[24px] flex items-center">
                                <span i18n="@@other_loan_product_information" class="font-semibold leading-tight">Other Loan<br>Product Information</span>
                            </div>
                            <div class="grid gap-x-[10px] gap-y-[5px] items-center grid-cols-[1fr_70px_1fr_70px]">
                                <!-- Row 1: Amortization Type | Compulsory Savings -->
                                <mat-label i18n="@@amortization_type_field">Amortization Type <span class="text-error">*</span></mat-label>
                                <mat-form-field appearance="outline" class="short_height w-full">
                                    <mat-select value="day" formControlName="amortizationType">
                                        <mat-option i18n="@@flat" value="NORMAL">Flat</mat-option>
                                        <mat-option i18n="@@baloon" value="BALLOON">Balloon</mat-option>
                                        <mat-option i18n="@@upfront_interest" value="UPFRONT_INTEREST">Upfront Interest</mat-option>
                                        <mat-option value="REDUCING_BALANCE" i18n="@@reducing_balance">Reducing Balance</mat-option>
                                        <mat-option value="STRAIGHT_LINE" i18n="@@straight_line">Straight Line</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-label i18n="@@compulsory_savings">Compulsory Savings</mat-label>
                                <div class="flex items-center gap-[5px]">
                                    <mat-form-field appearance="outline" class="short_height w-[70px] shrink-0">
                                        <mat-select formControlName="compulsorySavingsType" (selectionChange)="checkCompulsorySavingsType($event)">
                                            <mat-option i18n="@@none" value="NONE">None</mat-option>
                                            <mat-option i18n="@@flat" value="FLAT">Flat</mat-option>
                                            <mat-option i18n="@@percentage_of_principal" value="PERCENTAGE_OF_PRINCIPAL">Percentage of Principal</mat-option>
                                            <mat-option i18n="@@percentage_of_instalment" value="PERCENTAGE_OF_INSTALMENT">Percentage of Installment</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="loanFormCtrl['compulsorySavingsType'].value !== 'NONE'" appearance="outline" class="short_height w-[70px] shrink-0">
                                        <mat-label i18n="@@amortization_type">{{ loanFormCtrl["compulsorySavingsType"].value === "FLAT" ? "Amount" : "Rate" }}</mat-label>
                                        <input *ngIf="loanFormCtrl['compulsorySavingsType'].value === 'FLAT'" type="tel" appCurrency matInput formControlName="compulsorySavingsAmount" />
                                        <input *ngIf="loanFormCtrl['compulsorySavingsType'].value !== 'FLAT'" type="text" appPercent matInput formControlName="compulsorySavingsAmount" (blur)="isPercentRange(loanForm,'compulsorySavingsType','compulsorySavingsAmount')" />
                                    </mat-form-field>
                                    <mat-form-field *ngIf="loanFormCtrl['compulsorySavingsType'].value !== 'NONE'" appearance="outline" class="short_height w-[70px] shrink-0">
                                        <mat-label i18n="@@savings_product">Savings Product</mat-label>
                                        <mat-select formControlName="savingsProductId">
                                            <mat-option [value]="product.id" *ngFor="let product of savingsProduct">{{ product.name }}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <!-- Row 2: Late Payment Charge | Prepayment Penalty -->
                                <mat-label i18n="@@late_payment_charge">Late Payment Charge</mat-label>
                                <mat-form-field appearance="outline" class="short_height w-full">
                                    <mat-select formControlName="latePaymentChargeId" (selectionChange)="latePaymentchargeIdChange($event.value)" (openedChange)="onPenaltyChargeDropdownOpen($event)">
                                        <mat-option i18n="@@none" [value]="null">None</mat-option>
                                        <mat-option [value]="penaltyCharge?.id" *ngFor="let penaltyCharge of penaltyChargeOptions">{{ penaltyCharge?.name }}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <mat-label i18n="@@prepayment_penalty">Prepayment Penalty</mat-label>
                                <div class="flex items-center gap-[5px]">
                                    <mat-form-field appearance="outline" class="short_height w-[70px] shrink-0">
                                        <mat-select formControlName="prepaymentPenaltyType" (selectionChange)="checkPrepaymentPenaltyType($event)">
                                            <mat-option i18n="@@none" value="NONE">None</mat-option>
                                            <mat-option i18n="@@flat" value="FLAT">Flat</mat-option>
                                            <mat-option i18n="@@percentage_of_principal" value="PERCENTAGE_OF_PRINCIPAL">Percentage of Principal</mat-option>
                                            <mat-option i18n="@@percentage_of_instalment" value="PERCENTAGE_OF_INSTALMENT">Percentage of Installment</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field *ngIf="loanFormCtrl['prepaymentPenaltyType'].value !== 'NONE'" appearance="outline" class="short_height w-[70px] shrink-0">
                                        <mat-label>
                                            <ng-container *ngIf="loanFormCtrl['prepaymentPenaltyType'].value === 'FLAT'"><span i18n="@@amount_label">Amount</span></ng-container>
                                            <ng-container *ngIf="loanFormCtrl['prepaymentPenaltyType'].value !== 'FLAT'"><span i18n="@@rate">Rate</span></ng-container>
                                        </mat-label>
                                        <input *ngIf="loanFormCtrl['prepaymentPenaltyType'].value === 'FLAT'" type="tel" appCurrency matInput formControlName="prepaymentPenaltyAmount" (blur)="isPercentRange(loanForm,'prepaymentPenaltyType','prepaymentPenaltyAmount')" />
                                        <input *ngIf="loanFormCtrl['prepaymentPenaltyType'].value !== 'FLAT'" type="text" appPercent matInput formControlName="prepaymentPenaltyAmount" (blur)="isPercentRange(loanForm,'prepaymentPenaltyType','prepaymentPenaltyAmount')" />
                                    </mat-form-field>
                                </div>

                                <!-- Row 3: Late Payment Grace Period | Working Days -->
                                <mat-label i18n="@@late_payment_grace_period">Late Payment Grace Period <span class="text-error">*</span></mat-label>
                                <mat-form-field appearance="outline" class="short_height w-full">
                                    <input type="text" appStrictNumbers matInput formControlName="latePaymentPeriodLength" />
                                </mat-form-field>
                                <mat-label i18n="@@working_days_field">Working Days <span class="text-error">*</span></mat-label>
                                <mat-form-field appearance="outline" class="short_height w-full">
                                    <mat-select formControlName="isCalenderDays">
                                        <mat-option i18n="@@working_days" value="WORKING">Working Days</mat-option>
                                        <mat-option i18n="@@calender_days" value="CALENDAR">Calendar Days</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <!-- Row 4: Rounding Multiple + hint -->
                                <mat-label i18n="@@rounding_multiple_field">Rounding Multiple <span class="text-error">*</span></mat-label>
                                <mat-form-field appearance="outline" class="short_height w-full">
                                    <input type="text" appStrictNumbers matInput formControlName="roundingMultiple" />
                                </mat-form-field>
                                <p class="rounding-hint col-span-2" i18n="@@rounding_multiple_hint">Level of decimal precision required for rounding up calculations for this product</p>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

  <!-- Fees/Charges Configuration -->
  <div class="mt-[30px] px-[15px]">
    <app-fee-charge-config
      #feeChargeConfig
      [charges]="charges"
      [rows]="feeChargeRows"
      [feeEventTypes]="feeEventTypes"
      [isDisabled]="isDisabled"
      (rowsChange)="syncFeeCharges($event)"
      (rowDeleted)="onFeeChargeDeleted($event)"
    ></app-fee-charge-config>
  </div>

    <div class="mt-[30px] px-[15px]">
        <app-drag-drop-list [isDisabled]="isDisabled" [accountingCategories]="accountingCategories" [glAccounts]="glAccounts" [events]="events" [charges]="charges" [penaltyCharges]="penaltyCharges" [eventMaps]="eventMaps" [accountType]="activeAccountType" [createDefaultTxn]="!isViewMode" [feeChargeRows]="feeChargeRows"            (switchAccountTypeEmit)="switchAccountType($event)" (emitAccountingList)="submit($event)"></app-drag-drop-list>
        <div class="flex gap-[20px] mb-[50px] justify-end">
            <app-button-icon-ui *ngIf="isViewMode && isDisabled" [buttonType]="'button'" classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]" (clickEmit)="editForm($event)" name="Edit" value="edit" i18n-name="@@edit_button"></app-button-icon-ui>
            <app-button-icon-ui *ngIf="isViewMode && !isDisabled" [buttonType]="'button'" classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]" [isDisabled]="!isChanged || basicForm.invalid || loanForm.invalid" (clickEmit)="editForm($event)" name="Save"
                value="save" i18n-name="@@saveButton"></app-button-icon-ui>
            <app-button-icon-ui *ngIf="!isViewMode" [buttonType]="'button'" classNames="px-[33px] py-[14px] rounded-[10px] text-white bg-success/90 hover:bg-success w-[120px] h-[45px]" [isDisabled]="basicForm.invalid || loanForm.invalid" (clickEmit)="submitForm()" name="Submit" value="submit" i18n-name="@@submit"></app-button-icon-ui>
            <app-button-icon-ui [buttonType]="'button'" classNames="px-[33px] py-[14px] rounded-[10px] border border-error opacity-80 hover:opacity-100 text-error w-[120px] h-[45px]" (clickEmit)="cancel()" name="Cancel" value="cancel" i18n-name="@@cancel"></app-button-icon-ui>
        </div>
    </div>
</div>
